module.exports = __webpack_public_path__ + "static/media/2.ee9fc820.png";